export default __webpack_public_path__ + "static/media/mecha_927_4.7515fb01.jpg";